import React from 'react';
import { NavLink } from 'react-router-dom';

export default function PageNavigation() {
    return (
        <ul className="navigation-tabs__list">
            <li className="navigation-tabs__list-item">
                <NavLink
                    to="welcome-reminders"
                    className={({ isActive }) =>
                        isActive
                            ? 'navigation-tabs__link navigation-tabs__link--active'
                            : 'navigation-tabs__link'
                    }
                >
                    Welcome reminders
                </NavLink>
            </li>
            <li className="navigation-tabs__list-item">
                <NavLink
                    to="email-retention"
                    className={({ isActive }) =>
                        isActive
                            ? 'navigation-tabs__link navigation-tabs__link--active'
                            : 'navigation-tabs__link'
                    }
                >
                    Email retention
                </NavLink>
            </li>
            <li className="navigation-tabs__list-item">
                <NavLink
                    to="sms-retention"
                    className={({ isActive }) =>
                        isActive
                            ? 'navigation-tabs__link navigation-tabs__link--active'
                            : 'navigation-tabs__link'
                    }
                >
                    SMS retention
                </NavLink>
            </li>
        </ul>
    );
}
